// Route segments that are entity ids (cuid/cuid2, uuid, numeric) are collapsed
// so Grafana views group by page, not by individual entity. The match is
// intentionally lossy: false positives (e.g. a "2026" year segment collapsing
// to :id) only merge two page templates together — never split one — which is
// the safe direction for RUM aggregation.
const ID_SEGMENT_PATTERN = /^(c[a-z0-9]{20,32}|[0-9a-f]{8}-[0-9a-f-]{27}|\d+)$/i;

export function normalizeRoutePath(pathname: string): string {
  const normalized = pathname
    .split("/")
    .map((segment) => (ID_SEGMENT_PATTERN.test(segment) ? ":id" : segment))
    .join("/");
  return normalized || "/";
}
